export interface RevenueAccount {
  accountNo: number
  description: string
}

export interface RevenueAccountOption {
  value: RevenueAccount
  label: string
}

/**
 * Builds a SelectInput option for a revenue account. Returns `null` for a missing account so that
 * callers can pass through the result of an `Array.find()` without guarding beforehand.
 */
export const accountToOption = (account?: RevenueAccount | null): RevenueAccountOption | null => {
  if (!account) return null
  return {
    value: account,
    label: `(${account.accountNo}) ${account.description}`,
  }
}

export const accountsToOptions = (accounts: RevenueAccount[] = []): RevenueAccountOption[] =>
  accounts
    .map(accountToOption)
    .filter((option): option is RevenueAccountOption => option !== null)

/**
 * Looks up the option for an account number. The number may come from the tenant setting (string)
 * or from the chart of accounts group default (number), and it may point at an account that is not
 * part of the current account list at all — in that case there is nothing to preselect.
 */
export const findAccountOption = (
  accounts: RevenueAccount[] = [],
  accountNo?: number | string | null,
): RevenueAccountOption | null => {
  if (accountNo === null || accountNo === undefined || accountNo === '') return null
  const wantedAccountNo = Number(accountNo)
  if (!Number.isFinite(wantedAccountNo)) return null
  return accountToOption(accounts.find(account => Number(account.accountNo) === wantedAccountNo))
}
